import React from 'react';
import { Box, Stack } from '@mui/material';
import { usePreparationPhase } from './hooks/usePreparationPhase';
import PreparationHeader from './components/PreparationHeader';
import PreparationInsightStrip from './components/PreparationInsightStrip';
import PreparationPhilosophy from './components/PreparationPhilosophy';
import PreparationFilters from './components/PreparationFilters';
import PreparationAlerts from './components/PreparationAlerts';
import PreparationCandidatesTable from './components/PreparationCandidatesTable';
import PreparationHistoryTable from './components/PreparationHistoryTable';
import PreparationDetailDrawer from './components/PreparationDetailDrawer';

export default function PreparationPhasePage() {
  const prep = usePreparationPhase();

  return (
    <Box sx={{ p: { xs: 1.25, md: 1.75 }, maxWidth: 1680, mx: 'auto' }}>
      <Stack spacing={1.25}>
        <PreparationHeader
          t={prep.t}
          scoreDate={prep.data?.score_date}
          exportingImage={prep.exportingImage}
          candidatesCount={prep.candidates.length}
          refreshInFlight={prep.refreshInFlight}
          loading={prep.loading}
          onExportTable={prep.handleExportTableImage}
          onTriggerRefresh={prep.handleTriggerRefresh}
          onReload={() => prep.load()}
        />

        <PreparationInsightStrip
          t={prep.t}
          philosophyOpen={prep.philosophyOpen}
          onTogglePhilosophy={() => prep.setPhilosophyOpen((v) => !v)}
        />

        <PreparationPhilosophy t={prep.t} open={prep.philosophyOpen} />

        <PreparationFilters
          t={prep.t}
          i18n={prep.i18n}
          filters={prep.filters}
          setFilters={prep.setFilters}
          metadata={prep.metadata}
          loading={prep.loading}
          getRegimeLabel={prep.getRegimeLabel}
          onApply={prep.applyFilters}
        />

        <PreparationAlerts
          t={prep.t}
          error={prep.error}
          metadataError={prep.metadataError}
          refreshError={prep.refreshError}
          refreshTask={prep.refreshTask}
          refreshFailed={prep.refreshFailed}
          refreshSucceeded={prep.refreshSucceeded}
          refreshStatusLabel={prep.refreshStatusLabel}
          regimeWarning={prep.regimeWarning}
        />

        <PreparationCandidatesTable
          t={prep.t}
          i18n={prep.i18n}
          tableExportRef={prep.tableExportRef}
          loading={prep.loading}
          candidates={prep.candidates}
          stats={prep.stats}
          topScore={prep.topScore}
          avgScore={prep.avgScore}
          fmtNum={prep.fmtNum}
          fmtPct={prep.fmtPct}
          fmtMultiplier={prep.fmtMultiplier}
          getSignalLabel={prep.getSignalLabel}
          getRegimeLabel={prep.getRegimeLabel}
          getTriggerLabel={prep.getTriggerLabel}
          getSectorLabel={prep.getSectorLabel}
          getSignalHint={prep.getSignalHint}
          localizeReason={prep.localizeReason}
          onOpenDetail={prep.openLiveDetail}
        />

        <PreparationHistoryTable
          t={prep.t}
          numberLocale={prep.numberLocale}
          historyLoading={prep.historyLoading}
          historyItems={prep.historyItems}
          historyTone={prep.historyTone}
          fmtNum={prep.fmtNum}
          fmtPct={prep.fmtPct}
          onOpenHistoryDetail={prep.openHistoryDetail}
        />

        <PreparationDetailDrawer
          t={prep.t}
          i18n={prep.i18n}
          detailDrawer={prep.detailDrawer}
          setDetailDrawer={prep.setDetailDrawer}
          detailHistory={prep.detailHistory}
          drawerExportRef={prep.drawerExportRef}
          drawerBodyRef={prep.drawerBodyRef}
          exportingDrawer={prep.exportingDrawer}
          exportingChart={prep.exportingChart}
          chartExportRef={prep.chartExportRef}
          onExportDrawer={prep.handleExportDrawerImage}
          onExportChart={prep.handleExportChartImage}
          fmtNum={prep.fmtNum}
          fmtPct={prep.fmtPct}
          fmtPercentUnits={prep.fmtPercentUnits}
          fmtMultiplier={prep.fmtMultiplier}
          getTriggerLabel={prep.getTriggerLabel}
          getSectorLabel={prep.getSectorLabel}
          localizeReason={prep.localizeReason}
          getTier={prep.getTier}
          getPillarVerdict={prep.getPillarVerdict}
        />
      </Stack>
    </Box>
  );
}
